import React, { useState } from "react";
import { Box } from "@mui/material";
import {
  List,
  // useListController
} from "react-admin";
import CalendarView from "../calendar/CalendarView";
import CalendarToggleButton from "../calendar/CalendarToggleButton";
import {
  ScheduleView,
  // StudentServicePath, WEEKLY_TABBED_SCHEDULE
} from "utils/constants";
import { mguExporter } from "utils/tenants";
// import { DownloadXlsButton } from "features/XlsButton";

const ScheduleWrapper = ({ title, filters, children }) => {
  const [view, setView] = useState(ScheduleView.calendar);

  //do not remove: examle for xls download button use if be generate existing
  // const { filterValues, page, perPage, sort } = useListController();

  const handleViewChange = (event, newView) => {
    if (newView !== null) setView(newView);
  };

  return (
    <Box>
      <CalendarToggleButton
        view={view}
        handleViewChange={handleViewChange}
      />
      {view === ScheduleView.table ? (
        <List
          title={title}
          filter={filters}
          exporter={mguExporter}
          //for feature when there is BE endpoint who generated xls file
          // actions={
          //   <DownloadXlsButton
          //     customResources={`${StudentServicePath}${WEEKLY_TABBED_SCHEDULE}`}
          //     fileName={"student_schedules_weekly"}
          //     filterParams={{ filterValues, page, perPage, sort }}
          //   />
          // }
        >
          {children}
        </List>
      ) : (
        <CalendarView filters={filters} />
      )}
    </Box>
  );
};

export default ScheduleWrapper;
